import React, { useEffect, useState } from "react";
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  EditButton,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  useDataProvider,
  Title,
} from "react-admin";
import { db } from "../firebase/firebase";
import { addDoc, collection } from "firebase/firestore";

// -------- LIST --------
export const AccountList = () => {
  const dataProvider = useDataProvider();
  const [totalBalance, setTotalBalance] = useState(0);

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const { data } = await dataProvider.getList("accounts", {
          pagination: { page: 1, perPage: 500 },
        });

        const total = data.reduce(
          (sum, acc) => sum + (acc.currentBalance || acc.openingBalance || 0),
          0
        );
        setTotalBalance(total);
      } catch (err) {
        console.error("Error loading accounts:", err);
      }
    };
    fetchAccounts();
  }, [dataProvider]);

  return (
    <List>
      <Title title="Accounts List" />
      <div
        style={{
          padding: "10px 20px",
          fontWeight: "bold",
          fontSize: "16px",
          background: "#f9f9f9",
          borderBottom: "1px solid #ddd",
        }}
      >
        💰 Total Available Balance: {totalBalance.toFixed(2)} AED
      </div>

      <Datagrid rowClick="edit">
        <TextField source="name" label="Account Head" />
        <NumberField
          source="openingBalance"
          label="Opening Balance (AED)"
          options={{ minimumFractionDigits: 2 }}
          emptyText="0.00"
        />
        <NumberField
          source="currentBalance"
          label="Current Balance (AED)"
          options={{ minimumFractionDigits: 2 }}
          emptyText="0.00"
        />
        <EditButton />
      </Datagrid>
    </List>
  );
};

// -------- CREATE --------
export const AccountCreate = () => (
  <Create>
    <SimpleForm onSubmit={saveAccount}>
      <TextInput source="name" label="Account Head Name" fullWidth />
      <NumberInput source="openingBalance" label="Opening Balance (AED)" />
    </SimpleForm>
  </Create>
);

// -------- EDIT --------
export const AccountEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" label="Account Head Name" disabled />
      <NumberInput
        source="openingBalance"
        label="Opening Balance (AED)"
        disabled
      />
      <NumberInput
        source="currentBalance"
        label="Current Balance (AED)"
        disabled
      />
    </SimpleForm>
  </Edit>
);

// -------- SAVE FUNCTION --------
async function saveAccount(values) {
  try {
    const { name, openingBalance } = values;
    const opening = Number(openingBalance) || 0;

    // Auto-create account with currentBalance = openingBalance
    await addDoc(collection(db, "accounts"), {
      name,
      openingBalance: opening,
      currentBalance: opening,
      createdAt: new Date(),
    });

    alert("✅ Account created successfully!");
    window.location.reload();
  } catch (err) {
    console.error("❌ Error creating account:", err);
    alert("Error: " + err.message);
  }
}
